<div class="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v6" id="kt_login">
	<div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">
		<!--begin::Aside-->
		<div class="kt-grid__item  kt-grid__item--order-tablet-and-mobile-2  kt-grid kt-grid--hor kt-login__aside">
			<router-outlet></router-outlet>
		</div>
		<!--end::Aside-->
		<!--begin::Content-->
		<div *ngIf="!isMobile" class="kt-grid__item kt-grid__item--fluid kt-grid__item--center kt-grid kt-grid--ver kt-login__content" style="background-image: url(assets/media/bg/bg-4.jpg);">
			<div class="kt-login__section">
			</div>
		</div>
		<!--end::Content-->
	</div>
</div>
